import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarModule } from '@factorialco/f0-react'

import FeaturesList from 'modules/upsell/components/SelfUpsell/CheckoutModal/FeaturesList'
import { moduleAvailableToModuleId } from 'modules/upsell/lib/moduleIcons'
import type Plan from 'modules/upsell/lib/selfUpsell/plans/Plan'
import { BUSINESS_VARIANT } from 'modules/upsell/lib/selfUpsell/plans/utils'

type LeftSectionProps = {
  addon: Plan
  variant: string | undefined
  step: string
  iconName: string
}

const LeftSection = ({ addon, variant, step, iconName }: LeftSectionProps) => {
  const showFeatures = step === 'first'
  const moduleId = moduleAvailableToModuleId(iconName)

  return (
    <Box
      padding="s24"
      paddingBottom="s0"
      background="grey100"
      borderRadius={{
        topLeft: 'abs016',
        bottomLeft: 'abs016',
      }}
      style={{
        width: '40%',
        position: 'relative',
      }}
    >
      <Box gap="s16" paddingBottom="s16">
        <F0AvatarModule module={moduleId} size="lg" />
        <Box gap="s6">
          <Text size="400" color="grey1000" weight="semibold">
            {addon.title}
          </Text>
          <Text.Normal size="200" color="grey700">
            {addon.description}
          </Text.Normal>
        </Box>
      </Box>
      <Box
        paddingBottom="s24"
        style={{
          overflowY: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        {showFeatures && (
          <FeaturesList addon={addon} selectedVariant={variant || BUSINESS_VARIANT} />
        )}
      </Box>
      <Box
        borderRadius={{
          bottomLeft: 'abs016',
        }}
        style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          right: '0',
          height: '80px',
          background: 'linear-gradient(to bottom, rgba(250, 250, 250, 0), rgba(250, 250, 250, 1))',
          pointerEvents: 'none',
        }}
      />
    </Box>
  )
}

export default LeftSection
